if(!customElements.get('quick-add-modal')){customElements.define('quick-add-modal',class QuickAddModal extends ModalDialog{constructor(){super();this.modalContent=this.querySelector('[id^="QuickAddInfo-"]')}
hide(preventFocus=!1){const cartNotification=document.querySelector('cart-notification')||document.querySelector('cart-drawer');if(cartNotification)cartNotification.setActiveElement(this.openedBy);const sdoTk=this._sdoTk=(this._sdoTk||0)+1;setTimeout(()=>{if(this._sdoTk===sdoTk&&!this.hasAttribute('open'))this.modalContent.innerHTML=''},450);if(preventFocus)this.openedBy=null;super.hide()}
show(opener){this._sdoTk=(this._sdoTk||0)+1;const modalOpener=opener.closest('.quick-add');if(modalOpener)modalOpener.classList.add('quick-add--visible');opener.classList.add('btn--loading');opener.setAttribute('aria-disabled',!0);opener.setAttribute('disabled',!0);fetch(opener.getAttribute('data-product-url')).then((response)=>response.text()).then((responseText)=>{const responseHTML=new DOMParser().parseFromString(responseText,'text/html');this._sdoDoc=responseHTML;const quickBuyContent=responseHTML.getElementById("quick-buy-content").content;Array.from(quickBuyContent.querySelectorAll("noscript")).forEach((noScript)=>noScript.remove());this.modalContent.replaceChildren(quickBuyContent);const imgsElm=this.modalContent.querySelectorAll('img');imgsElm.forEach((imgElm)=>{imgElm.onload=()=>{imgElm.classList.add('loaded')}});if(window.Shopify&&Shopify.PaymentButton){Shopify.PaymentButton.init()}
if(window.ProductModel)window.ProductModel.loadShopifyXR();if(window.sdoQaEnrichir)window.sdoQaEnrichir(this);requestAnimationFrame(()=>requestAnimationFrame(()=>{super.show(opener)}))}).finally(()=>{if(modalOpener)modalOpener.classList.remove('quick-add--visible');opener.removeAttribute('aria-disabled');opener.removeAttribute('disabled');opener.classList.remove('btn--loading')})}})}

/* Soleil d'Or · ajout rapide (Numerigram, octobre 2026).
   (Dans le code du thème ci-dessus : le contenu est vidé 450 ms après la fermeture et non
   tout de suite, pour que la fenêtre redescende pleine sur mobile au lieu de s'affaisser ;
   et l'ouverture attend deux images, une fois le contenu complété, pour une animation fluide.)
   La fenêtre reprend l'essentiel de la fiche parfum, lu dans la page produit
   déjà chargée par la fenêtre (this._sdoDoc) :
   - marque, nom et type (Extrait de Parfum…) ;
   - famille et intensité, notes de tête, de cœur et de fond ;
   - « Contenance » au lieu de « Sélectionner Contenance », prix au ml ;
   - variante épuisée : bouton « Soyez informé de son retour » qui ouvre la
     fiche et la fenêtre d'alerte Kbite (#sdo-notifier, voir kbite-modal-close.js) ;
   - une ligne de réassurance reprise du bandeau d'annonces (donc propre au marché). */
(function () {
  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var T = EN
    ? { notif: 'Notify me when it’s back', tete: 'Top', coeur: 'Heart', fond: 'Base' }
    : { notif: 'Soyez informé de son retour', tete: 'Tête', coeur: 'Cœur', fond: 'Fond' };

  function txt(el) {
    if (!el) return '';
    var c = el.cloneNode(true);
    [].forEach.call(c.querySelectorAll('.visually-hidden'), function (x) { x.remove(); });
    return c.textContent.replace(/\s+/g, ' ').trim();
  }
  function cree(tag, cls, contenu) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (contenu != null) e.textContent = contenu;
    return e;
  }
  function legende(doc) {
    var s = [].find.call(doc.querySelectorAll('script'), function (x) { return x.textContent.indexOf('"_legende"') > -1; });
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }

  function tete(zone, doc, modal) {
    if (zone.querySelector('.sdo-qa-tete')) return;
    var info = doc && doc.querySelector('.product__info-container');
    var t = cree('div', 'sdo-qa-tete');
    /* Petite photo à côté du nom, affichée seulement sur mobile (la grande galerie y est masquée) */
    var im = modal.querySelector('.product__media-wrapper img');
    if (im) {
      var src = im.currentSrc || '';
      if (!src && im.getAttribute('srcset')) src = im.getAttribute('srcset').split(',').pop().trim().split(' ')[0];
      if (!src) src = im.getAttribute('data-src') || im.getAttribute('src') || '';
      if (src) {
        var vg = cree('img', 'sdo-qa-vignette');
        vg.src = src; vg.alt = ''; vg.width = 72; vg.height = 90; vg.loading = 'lazy';
        t.appendChild(vg);
      }
    }
    var tx = cree('div', 'sdo-qa-tete__txt');
    t.appendChild(tx);
    if (info && info.querySelector('.product__title')) {
      tx.appendChild(cree('p', 'sdo-qa-marque', txt(info.querySelector('.product__vendor'))));
      tx.appendChild(cree('p', 'sdo-qa-nom', txt(info.querySelector('.product__title'))));
      var st = txt(info.querySelector('.sdo-fp-soustitre'));
      if (st) tx.appendChild(cree('p', 'sdo-qa-type', st));
      zone.insertBefore(t, zone.firstChild);
      return;
    }
    /* Secours : la page n'a pas pu être lue, on prend marque et nom dans /products/<handle>.js */
    var lien = modal.querySelector('.product__view-details');
    var url = lien && (lien.getAttribute('href') || '').split('?')[0];
    if (!url) return;
    fetch(url + '.js').then(function (r) { return r.json(); }).then(function (p) {
      if (zone.querySelector('.sdo-qa-tete')) return;
      tx.appendChild(cree('p', 'sdo-qa-marque', p.vendor || ''));
      tx.appendChild(cree('p', 'sdo-qa-nom', p.title || ''));
      zone.insertBefore(t, zone.firstChild);
    }).catch(function () {});
  }

  function profil(zone, doc) {
    if (!doc || zone.querySelector('.sdo-qa-profil')) return;
    var bloc = cree('div', 'sdo-qa-profil');
    var ex = doc.querySelector('.sdo-fp-express');
    if (ex) {
      var dl = cree('dl', 'sdo-qa-express');
      [].forEach.call(ex.querySelectorAll('.sdo-fp-express__cell'), function (c, i) {
        if (i > 1) return; /* famille et intensité seulement */
        dl.appendChild(c.cloneNode(true));
      });
      if (dl.children.length) bloc.appendChild(dl);
    }
    var noms = [T.tete, T.coeur, T.fond];
    var etages = doc.querySelectorAll('.sdo-fp-etage');
    if (etages.length) {
      var ul = cree('ul', 'sdo-qa-notes');
      [].forEach.call(etages, function (e, i) {
        var n = [].map.call(e.querySelectorAll('.sdo-fp-note__nom, .sdo-fp-notes__nom'), txt).filter(Boolean);
        if (!n.length) return;
        var li = cree('li');
        li.appendChild(cree('span', 'sdo-qa-notes__etage', txt(e.querySelector('.sdo-fp-etage__nom')) || noms[i] || ''));
        li.appendChild(cree('span', 'sdo-qa-notes__liste', n.slice(0, 4).join(', ')));
        ul.appendChild(li);
      });
      if (ul.children.length) bloc.appendChild(ul);
    }
    if (!bloc.children.length) return;
    var t = zone.querySelector('.sdo-qa-tete');
    if (t && t.nextSibling) zone.insertBefore(bloc, t.nextSibling); else zone.insertBefore(bloc, zone.firstChild);
  }

  function libelle(modal, leg) {
    var l = modal.querySelector('.product-form__label');
    if (!l || l.__sdo) return;
    l.__sdo = true;
    if (leg && leg._legende) { l.textContent = leg._legende; return; }
    l.textContent = l.textContent.replace(/\s+/g, ' ').trim().replace(/^(Sélectionner|Choisir|Select|Choose)\s+/i, '');
  }

  function reassurance(zone) {
    if (zone.querySelector('.sdo-qa-rass')) return;
    var vus = {};
    var items = [].map.call(document.querySelectorAll('.announcement-bar__message .announcement__text'), txt)
      .filter(function (s) {
        if (!s || vus[s]) return false;
        vus[s] = 1;
        return /livraison|shipping|delivery|retrait|pick-?up|click/i.test(s);
      }).slice(0, 2);
    if (!items.length) return;
    var ul = cree('ul', 'sdo-qa-rass');
    items.forEach(function (s) { ul.appendChild(cree('li', '', s)); });
    var bb = zone.querySelector('.product-form__buy-buttons');
    var apres = zone.querySelector('.sdo-qa-notif') || bb;
    if (apres && apres.parentNode) apres.parentNode.insertBefore(ul, apres.nextSibling);
  }

  function maj(modal) {
    var zone = modal.querySelector('.product__info-container');
    if (!zone) return;
    var leg = modal.__sdoLeg;
    var choix = [].map.call(modal.querySelectorAll('variant-selects input:checked, variant-selects select'), function (i) { return i.value; });
    /* Prix au ml */
    var prix = zone.querySelector('.product__price');
    var ml = zone.querySelector('.sdo-qa-ml');
    var note = '';
    if (leg && leg._v) choix.forEach(function (v) { if (leg._v[v] && leg._v[v].note) note = leg._v[v].note; });
    if (prix && note) {
      if (!ml) { ml = cree('p', 'sdo-qa-ml'); prix.parentNode.insertBefore(ml, prix.nextSibling); }
      ml.textContent = note.replace(/\\\//g, '/');
    } else if (ml) ml.remove();
    /* Rupture : bouton d'alerte */
    /* Disponibilité lue dans /products/<handle>.js (chargé une fois par fenêtre) plutôt que
       sur le bouton, qui est désactivé pendant le chargement de chaque variante. */
    var lien = modal.querySelector('.product__view-details');
    var url = lien && (lien.getAttribute('href') || '').split('?')[0];
    var bb = zone.querySelector('.product-form__buy-buttons');
    var a = zone.querySelector('.sdo-qa-notif');
    var p = modal.__sdoP;
    if (!p) {
      if (url && !modal.__sdoPEnCours) {
        modal.__sdoPEnCours = true;
        fetch(url + '.js').then(function (r) { return r.json(); }).then(function (j) { modal.__sdoP = j; maj(modal); }).catch(function () {});
      }
      return;
    }
    var v = (p.variants || []).find(function (x) {
      return choix.length && choix.every(function (c, i) { return (x.options || [])[i] === c; });
    });
    var id = v && v.id;
    var epuise = !!(v && !v.available);
    if (epuise && url && id && bb) {
      if (!a) {
        a = cree('a', 'sdo-qa-notif', T.notif);
        bb.parentNode.insertBefore(a, bb.nextSibling);
      }
      a.href = url + '?variant=' + id + '#sdo-notifier';
    } else if (a) a.remove();
  }

  function enrichir(modal) {
    var zone = modal.querySelector('.product__info-container');
    if (!zone || zone.__sdoFait) return;
    zone.__sdoFait = true;
    var doc = modal._sdoDoc || null;
    modal.__sdoLeg = doc ? legende(doc) : null;
    modal.classList.add('sdo-qa');
    tete(zone, doc, modal);
    profil(zone, doc);
    libelle(modal, modal.__sdoLeg);
    maj(modal);
    reassurance(zone);
    if (!modal.__sdoEcoute) {
      modal.__sdoEcoute = true;
      modal.addEventListener('change', function () {
        [80, 400, 1000].forEach(function (d) { setTimeout(function () { maj(modal); }, d); });
      });
    }
  }

  /* Appelé par la fenêtre juste avant son ouverture : tout est en place avant l'animation. */
  window.sdoQaEnrichir = function (m) { try { enrichir(m); } catch (e) {} };
  var obs = new MutationObserver(function () {
    document.querySelectorAll('quick-add-modal[open]').forEach(enrichir);
  });
  obs.observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });
})();
